import*as r from"react";import e from"./index.module.scss.js";var a=function(a){var t=a.children;return r.createElement("div",{className:e.navWrapper},t)};export{a as Navigation};
//# sourceMappingURL=Navigation.js.map
